import React, { useEffect, useState, useMemo } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { updateChequeEstado } from "../../../Api/ChequesApi";

const estadosPermitidos = (estadoActual) => {
  switch (estadoActual) {
    case "CREADO":
      return ["CREADO", "IMPRESO", "ANULADO"];
    case "IMPRESO":
      return ["IMPRESO", "ENTREGADO", "ANULADO"];
    case "ENTREGADO":
      return ["ANULADO"]; // 🔒 SOLO ANULAR
    default:
      return [];
  }
};

const ChequeEstadoModal = ({ show, onHide, cheque, onSaved }) => {
  const [estado, setEstado] = useState("");
  const [numeroderecibo, setNumeroDeRecibo] = useState("");
  const [motivodeanulado, setMotivoDeAnulado] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cheque && show) {
      setEstado(
        cheque.estado === "ENTREGADO" ? "ANULADO" : cheque.estado
      );
      setNumeroDeRecibo(cheque.numeroderecibo || "");
      setMotivoDeAnulado(cheque.motivodeanulado || "");
    }
  }, [cheque, show]);

  const opcionesEstado = useMemo(
    () => (cheque ? estadosPermitidos(cheque.estado) : []),
    [cheque]
  );

  const guardar = async () => {
    if (estado === "ANULADO" && !motivodeanulado.trim()) {
      alert("Debe ingresar el motivo de anulación");
      return;
    }

    setLoading(true);

    try {
      await updateChequeEstado(cheque.idcheque, {
        estado: "ANULADO",
        numeroderecibo: cheque.numeroderecibo ?? null,
        motivodeanulado,
      });

      onSaved();
      onHide();
    } catch (err) {
      console.error(err);
      alert("Error al actualizar el estado del cheque");
    } finally {
      setLoading(false);
    }
  };

  if (!cheque) return null;

  const esEntregado = cheque.estado === "ENTREGADO";
  const esAnulado = cheque.estado === "ANULADO";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar estado del cheque</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {esAnulado && (
          <Alert variant="danger">
            Este cheque ya está <b>ANULADO</b> y no puede modificarse.
          </Alert>
        )}

        {esEntregado && (
          <Alert variant="warning">
            El cheque fue <b>ENTREGADO</b>.  
            Solo se permite <b>ANULAR</b>.
          </Alert>
        )}

        {/* ESTADO */}
        <Form.Group className="mb-3">
          <Form.Label>Estado</Form.Label>
          <Form.Select value="ANULADO" disabled>
            <option value="ANULADO">ANULADO</option>
          </Form.Select>
        </Form.Group>

        {/* NUMERO DE RECIBO (solo lectura si existe) */}
        {cheque.numeroderecibo && (
          <Form.Group className="mb-3">
            <Form.Label>Número de recibo</Form.Label>
            <Form.Control value={numeroderecibo} disabled />
          </Form.Group>
        )}

        {/* MOTIVO DE ANULADO */}
        {!esAnulado && (
          <Form.Group className="mb-3">
            <Form.Label>Motivo de anulación</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={motivodeanulado}
              onChange={(e) => setMotivoDeAnulado(e.target.value)}
              placeholder="Indique el motivo de la anulación"
            />
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cerrar
        </Button>

        {!esAnulado && (
          <Button variant="danger" onClick={guardar} disabled={loading}>
            {loading ? "Anulando..." : "Anular cheque"}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ChequeEstadoModal;
